import { Link } from "react-router";
import { EmptyState, PageHeader } from "../components/ui";

export function NotFoundPage() {
  return (
    <div className="page">
      <PageHeader title="Not found" />
      <EmptyState title="There's nothing at this address.">
        <Link to="/stories">Back to Public Stories</Link>
      </EmptyState>
    </div>
  );
}
